import React, { useLayoutEffect, useRef, useState } from 'react';
import { Box, Text, Tooltip } from '@mantine/core';

const pillSx = {
  backgroundColor: '#f5f6f8',
  color: '#374151',
  borderRadius: 6,
  padding: '6px 12px',
  display: 'inline-flex',
  alignItems: 'center',
  border: '1px solid #e2e4e8',
  transition: 'background-color 0.15s ease, border-color 0.15s ease',
} as const;

const TOOLTIP_WIDTH_THRESHOLD = 380;

export interface SelectedFilterValuesProps {
  values: string;
}

const SelectedFilterValues: React.FC<SelectedFilterValuesProps> = ({ values }) => {
  const boxRef = useRef<HTMLDivElement>(null);
  const [showTooltip, setShowTooltip] = useState(false);

  useLayoutEffect(() => {
    const el = boxRef.current;
    if (!el) return;
    setShowTooltip(el.scrollWidth > TOOLTIP_WIDTH_THRESHOLD);
  }, [values]);

  const pill = (
    <Box ref={boxRef} sx={{ ...pillSx, width: 'auto', maxWidth: 358, minWidth: 0 }}>
      <Text size="xs" truncate>
        {values}
      </Text>
    </Box>
  );

  if (!showTooltip) return pill;

  return (
    <Tooltip width={480} label={values} maw={480} multiline withinPortal>
      {pill}
    </Tooltip>
  );
};

export default SelectedFilterValues;